import { apiClient } from './client';
import type { ApiResponse, PaginatedResponse, Dispatch, DispatchStatus } from '@/types/api.types';

export const dispatchesApi = {
  list: (params?: {
    page?: number;
    pageSize?: number;
    status?: DispatchStatus;
    campaignId?: string;
    from?: string;
    to?: string;
  }) => apiClient.get<PaginatedResponse<Dispatch>>('/dispatches', { params }),

  send: (data: { contactPhone: string; contactName?: string; payload: unknown }) =>
    apiClient.post<ApiResponse<Dispatch>>('/dispatches', data),

  retry: (id: string) =>
    apiClient.post(`/dispatches/${id}/retry`),

  getLogs: (id: string) =>
    apiClient.get<{ data: DispatchLog[] }>(`/dispatches/${id}/logs`),
};

export interface DispatchLog {
  id: number;
  dispatchId: string;
  eventType: string;
  payload: unknown | null;
  createdAt: string;
}
